import { styled } from 'styled-components';

import { StyledTooltipProps } from '@components/web/src/atoms/Tooltips/types';
import { COLORS, GRADIENTS, SHADOWS } from '@components/web/src/styles';

export const Tooltip = styled.div<StyledTooltipProps>`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 4px;
  align-items: start;
  border-radius: 8px;
  width: fit-content;
  max-width: 320px;
  box-shadow: ${SHADOWS.lg};
  padding: ${({ $isDescription }) => ($isDescription ? '12px;' : '8px 12px;')};
  background: ${({ $variant }) => {
    switch ($variant) {
      case 'light':
        return COLORS.base.white;
      case 'dark':
        return COLORS.gray['500'];
      case 'green':
        return COLORS.green['600'];
      case 'gradient':
        return GRADIENTS.primaryGradient;
      default:
        return COLORS.base.white;
    }
  }};
  p {
    margin: 0px;
  }
`;
